// import { CircularProgress } from "@mui/material"

// import { CircularProgress } from "@mui/material";
import { Spinner } from "react-bootstrap";
import { BsCircleSquare } from "react-icons/bs";

export function LoadingIndicator() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height:'100%'
      }}
    >
      <Spinner variant="indeterminate" color="#6d9e99"/>
    </div>
  )
}